import bsn from 'libraries/bootstrap-native.js';

import analytics from 'analytics.js';
import events from 'events.js';
import query from 'query.js';

function trackPhoneClick(elem) {
    const data = {
        practitioner: elem.dataset.profileId,
        phone_number: elem.dataset.phone,
        practice_position: elem.dataset.practiceId,
    };
    const healthFund = query.parse().health_fund;
    if (healthFund) {
        data.health_fund = healthFund;
    }
    analytics.track('practitionerPhoneClick', data);
}

function showContactModal(practitionerName, phoneNumber, pro) {
    const modalTitle = document.getElementsByClassName('js-modal-title')[0];
    const displayName = document.body.dataset.displayName;
    modalTitle.text = `Contact details for ${displayName}`;

    const contactNumberId = `hcp-contact-number-${pro ? 'pro' : 'non-pro'}`;
    const modalId = `contact-modal-${pro ? 'pro' : 'non-pro'}`;
    const contactNumber = document.getElementById(contactNumberId);
    contactNumber.text = `Call ${phoneNumber}`;

    for (const pn of Array.from(
        document.getElementsByClassName('js-profile-name'),
    )) {
        pn.innerText = practitionerName;
    }

    const number = phoneNumber.replace(/\s/g, '');
    document.getElementById(contactNumberId).href = `tel:${number}`;
    new bsn.Modal(document.getElementById(modalId)).show();
}

(async function () {
    await events.ready();

    const pltd = document.body.dataset.practitionerListTrackData;
    if (pltd) {
        analytics.track('practitionerList', JSON.parse(pltd));
    }

    const details = document.querySelectorAll('a.contact-details');
    for (const detail of details) {
        events.listen(detail, 'click', (evt) => {
            evt.preventDefault();
            const number = detail.querySelector('dd[data-phone]');
            const practitionerName = number.dataset.name;
            const isPro = typeof number.dataset.pro !== 'undefined';
            if (
                number.getAttribute('data-phone') &&
                number.getAttribute('data-id') !== 'fax'
            ) {
                trackPhoneClick(number);
                showContactModal(
                    practitionerName,
                    decodeURI(number.getAttribute('data-phone')),
                    isPro,
                );
            }
        });
    }
})();
